<script setup lang="ts">
import { Enums } from "@/enums";
import { VR } from "@/widgets";
import { isNil } from "es-toolkit";
import { computed } from "vue";
import { privileges } from "../../common/privilege.common";
import { FinancePaymentRoutes } from "../../pages/finance_payment/finance_payment.route";

const props = defineProps<{
    invoiceId: string;
    paymentMethod: Enums.PaymentMethodEnum.Values | undefined;
    paymentChannel: string | undefined;
    paymentDate: string | undefined;
    paymentAuthor: string | undefined;
}>();

const showUpdateButton = computed(() => {
    if (isNil(props.paymentMethod)) return false;
    if (!privileges.has("financeInvoice.update")) return false;
    const allowedMethods: Enums.PaymentMethodEnum.Values[] = ["C", "X"];
    return allowedMethods.includes(props.paymentMethod);
});
</script>

<template>
    <table class="rns-table-form">
        <tbody>
            <tr v-if="props.paymentMethod !== undefined">
                <td>Metode Pembayaran</td>
                <td>:</td>
                <td>
                    {{ Enums.PaymentMethodEnum.label(props.paymentMethod) }}
                    <template v-if="props.paymentChannel !== undefined"> ({{ props.paymentChannel }})</template>
                </td>
                <td v-if="showUpdateButton" rowspan="2">
                    <VR.RouterLink v-tooltip.left="'Ubah'" :to="FinancePaymentRoutes.to.update(props.invoiceId)">
                        <i class="pi pi-pencil"></i>
                    </VR.RouterLink>
                </td>
            </tr>
            <tr v-if="props.paymentDate !== undefined">
                <td>Waktu Pembayaran</td>
                <td>:</td>
                <td>{{ props.paymentDate }}</td>
            </tr>
            <tr v-if="props.paymentAuthor !== undefined">
                <td>Petugas Pembayaran</td>
                <td>:</td>
                <td>{{ props.paymentAuthor }}</td>
            </tr>
        </tbody>
    </table>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-table-form {
    @apply pl-4 w-full h-full;
}

.rns-table-form tr td {
    @apply align-top;
}

.rns-table-form > tbody > tr > td:nth-child(1) {
    @apply font-semibold w-36 pl-4 whitespace-nowrap;
}

.rns-table-form > tbody > tr > td:nth-child(2) {
    @apply w-3 px-2;
}
</style>
